// React
import React from "react";

// UI and Styling
import {
  Dialog,
  DialogContent,
  DialogActions,
  makeStyles,
  Typography
} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    background: "#c31d1d",
    color: "#FFF"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  modal: {
    height: "70vh",
  },
}));

const Modal = ({
  actions,
  children,
  fixedHeight,
  fixedHeightValue,
  fullWidth,
  handleClose,
  open,
  title
}) => {
  const classes = useStyles();

  return (
    <Dialog
      maxWidth={"md"}
      fullWidth={fullWidth}
      open={open}
      aria-labelledby="scroll-dialog-title"
      onClose={handleClose}
    >
      <MuiDialogTitle
        disableTypography
        className={classes.root}
        id="scroll-dialog-title"
      >
        <Typography variant="h6">{title}</Typography>
      </MuiDialogTitle>
      <DialogContent className={classes.modal}>
        {children}
      </DialogContent>
      <DialogActions className={classes.buttonBar}>{actions}</DialogActions>
    </Dialog>
  );
};

export default Modal;
